import { SessionActions } from './../actions/session';
import {
  RemoveFavouriteAuctionAction,
  StoreFavouriteAuctionAction
} from '../actions/favouriteAuctions';

type HydrateFavouriteAuctionsAction = {
  type: 'HYDRATE_FAVOURITE_AUCTIONS_SUCCESS';
  favouriteAuctions: Record<string, string>[];
};

const withAuctionId = (state: string[], auctionId: string) => {
  if (state.includes(auctionId)) {
    return state;
  }

  return [...state, auctionId];
};

const favouriteAuctions = (
  state: string[] = [],
  action:
    | SessionActions
    | StoreFavouriteAuctionAction
    | RemoveFavouriteAuctionAction
    | HydrateFavouriteAuctionsAction
) => {
  switch (action.type) {
    case 'STORE_FAVOURITE_AUCTION_REQUEST':
    case 'REMOVE_FAVOURITE_AUCTION_FAILURE':
      return withAuctionId(state, action.payload);
    case 'REMOVE_FAVOURITE_AUCTION_REQUEST':
    case 'STORE_FAVOURITE_AUCTION_FAILURE':
      return state.filter(auctionId => auctionId !== action.payload);
    case 'HYDRATE_FAVOURITE_AUCTIONS_SUCCESS':
      return action.favouriteAuctions.map(favourite => favourite.id);
    case 'SESSION_DESTROY_SUCCESS':
      return [];
    default:
      return state;
  }
};

export default favouriteAuctions;
